// Core

// Components
import AppBar from "@components/AppBar";
import { useWavesTabsConfig } from "@hooks";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";
import { useLocation } from "react-router-dom";
import LinkButton from "./LinkButton";

export type LayoutDefaultElement = HTMLDivElement;

export type LayoutDefaultProps = {
  title: string;
  className?: string;
};

export const LayoutDefault = React.forwardRef<
  LayoutDefaultElement,
  React.PropsWithChildren<LayoutDefaultProps>
>(({ children, className }, ref) => {
  const theme = useTheme();
  const location = useLocation();

  const wavesTabsConfig = useWavesTabsConfig();

  const wavesTabs: JSX.Element[] = wavesTabsConfig.map((tabConfig) => (
    <LinkButton
      path={tabConfig.path}
      label={tabConfig.label}
      key={tabConfig.label}
      active={location.pathname.includes(tabConfig.path)}
    />
  ));

  const contentHeight = `calc(${theme.customLayoutHeight.rootHeight} - ${theme.customLayoutHeight.appNavBarHeight})`;

  return (
    <div
      ref={ref}
      className={className}
      style={{
        height: theme.customLayoutHeight.rootHeight,
        width: "100%",
        display: "flex",
        flexDirection: "column"
      }}
    >
      <AppBar tabs={wavesTabs} />
      <Box
        id="main-content-container"
        sx={{
          height: contentHeight,
          overflow: "auto",
          width: "100%"
        }}
      >
        {children}
      </Box>
    </div>
  );
});

export default LayoutDefault;
